export enum ExpiryTargetType {
  Internal = 1,
  Public = 2,
  Retailer = 3,
  FromSupplier = 4
}

(ExpiryTargetType as any).__typeName = 'ExpiryTargetType';
